import SmallLabel from './SmallLabel';

export default SmallLabel;
